import moment from 'moment';

const scrollTo = function scrollTo(hash) {
  if (typeof ($(hash).offset()) === 'undefined') return;
  $('body').animate({
    scrollTop: $(hash).offset().top - 100,
  }, 500);
};

const pluralizeLikes = function pluralizeLikes(num) {
  if (typeof (num) === 'undefined') return '';
  if (num > 1) {
    return num.toLocaleString() + ' ' + I18n.t('javascript.community.response.childComments.like.plural');
  } else if (num === 0) {
    return I18n.t('javascript.community.response.childComments.like.singular');
  } else {
    return num.toLocaleString() + ' ' + I18n.t('javascript.community.response.childComments.like.singular');
  }
};

/*
 * num - number to pluralize, integer
 * noun - object that you are counting, string
 * hideZero - suppress 0 if num is 0, boolean
 */
const pluralize = function pluralize(num, noun, hideZero) {
  const snouns = ['Like'];
  const esnouns = [];
  const plural = (num > 1);
  if (plural) {
    if (snouns.indexOf(noun) > 0) {
      noun = noun + 's';
    } else {
      if (esnouns.indexOf(noun) > 0) {
        noun = noun + 'es';
      }
    }
  }
  if (hideZero && num === 0) {
    return noun;
  } else {
    return num.toLocaleString() + ' ' + noun;
  }
}``;

const fullName = function fullName(user) {
  return user.first_name + ' ' + user.last_name;
};

const relativeTime = function relativeTime() {
  $('[data-relative-time]').each(function makeRelativeTime() {
    const time = $(this).data('relative-time');
    const relativeTime = moment(time).fromNow();
    $(this).text(relativeTime);
  });
};

const simpleFormat = function simpleFormat(str) {
  str = str.replace(/\r\n?/, '\n');
  str = $.trim(str);
  if (str.length > 0) {
    str = str.replace(/\n\n+/g, '</p><p>');
    str = str.replace(/\n/g, '<br />');
    str = '<p>' + str + '</p>';
  }
  return str;
};

const helpers = {
  scrollTo,
  pluralizeLikes,
  pluralize,
  fullName,
  relativeTime,
  simpleFormat,
};

export default helpers;
